import { API_BASE_URL } from "../../constants/index";
import { buildUrl } from "../../utilities/index";
import HttpInterface from "../../helpers/HttpInterface";

export class BrandSettingsService {
  constructor() {
    this.httpProxy = new HttpInterface();
  }

  getBrandSettingPublic(slug, params = {}) {
    const requestOptions = {
      method: "GET",
    };
    return this.httpProxy.fetch(
      buildUrl(
        `${API_BASE_URL}/registry-service/brand-settings/public/setting${
          slug ? `/${slug}` : ""
        }`,
        params
      ),
      requestOptions
    );
  }
}
